import { AUTH_PAGE_SLUG } from "@/app/[locale]/(default)/auth/constants";
import { CHECKOUT_PAGE_SLUG } from "@/app/[locale]/(default)/checkout/constants";
import { FAQ_PAGE_SLUG } from "@/app/[locale]/(default)/faq/constants";
import { FREE_TRIAL_PAGE_SLUG } from "@/app/[locale]/(default)/free-trial/constants";
import { NESTED_STORE_LOCATOR_SLUG } from "@/app/[locale]/(default)/nested-store-locator/constants";
import { PROFILE_PAGE_SLUG } from "@/app/[locale]/(default)/profile/constants";
import { SHOP_PAGE_SLUG } from "@/app/[locale]/(default)/shop/constants";
import { BLOG_SLUG, LOYALTY_BLOG_SLUG } from "@/utils/buildBlogSlug";

type RewritableSegment =
  | typeof SHOP_PAGE_SLUG
  | typeof LOYALTY_BLOG_SLUG
  | typeof BLOG_SLUG
  | typeof FAQ_PAGE_SLUG
  | typeof FREE_TRIAL_PAGE_SLUG
  | typeof CHECKOUT_PAGE_SLUG
  | typeof AUTH_PAGE_SLUG
  | typeof PROFILE_PAGE_SLUG
  | typeof NESTED_STORE_LOCATOR_SLUG;

export const isSegmentRewritable = (segment: string): segment is RewritableSegment => {
  return (
    segment === SHOP_PAGE_SLUG ||
    segment === LOYALTY_BLOG_SLUG ||
    segment === BLOG_SLUG ||
    segment === FAQ_PAGE_SLUG ||
    segment === FREE_TRIAL_PAGE_SLUG ||
    segment === CHECKOUT_PAGE_SLUG ||
    segment === AUTH_PAGE_SLUG ||
    segment === PROFILE_PAGE_SLUG ||
    segment === NESTED_STORE_LOCATOR_SLUG
  );
};
